<template>
  <div class="login-container">
    <div :class="`login-container__login-body ${$platform}`">
      <img :class="`login-container__login-body__logo ${$platform}`" :src="`sh_static/header/optimizer-${$platform}-logo.svg`">
      <div class="login-container__login-body__form">
        <h5 :class="`login-form-title ${$platform}`">
          Welcome, please sign in!
        </h5>
        <div :class="[ $validator.errors.has('username') ? 'form-group-error' : '', 'optimizer-form-group']">
          <input :disabled="loading" type="text" @keyup.enter="$_loginAction" v-model="username" v-validate="'required'" data-vv-as="Username" name="username" :class="`form-input form-control ${$platform}`" placeholder="Username">
          <small :class="[ $validator.errors.has('username') ? 'show-error' : '', 'form-error-text']"><span>{{ $validator.errors.first('username') }}</span></small>
        </div>
        <div :class="[ $validator.errors.has('password') ? 'form-group-error' : '', 'optimizer-form-group']">
          <input :disabled="loading" type="password" @keyup.enter="$_loginAction" v-model="password" v-validate="'required'" data-vv-as="Password" name="password" :class="`form-input form-control ${$platform}`" placeholder="Password">
          <small :class="[ $validator.errors.has('password') ? 'show-error' : '', 'form-error-text']"><span>{{ $validator.errors.first('password') }}</span></small>
        </div>
        <a href="https://membership.theoptimizer.io/login" class="form-link">Forgot your password?</a>
        <b-btn :disabled="loading" @click="$_loginAction" :class="`primary-button login-btn ${$platform}`">
          <template v-if="loading"><i class="fa fa-spinner fa-spin"></i> </template> Sign In
        </b-btn>
        <div v-if="showPaymentError" class="error-message">
          <div v-html="paymentErrorText"></div>
          <a :href="paymentLink" class="form-link"> Please click here to renew your subscription.</a>
        </div>
        <p v-if="!showPaymentError" class="sign-up-text">
          Don't have an Optimizer account? <a :href="$c_signupUrl" class="form-link">Create Account</a>
        </p>
      </div>
    </div>
    <div class="login-container__platforms">
      <img class="optimizer-hexagon-img" src="sh_static/utils/optimizer-hexagon.png">
      <div class="login-container__platforms__content">
        <h1 class="login-container__platforms__content__title mb-5">
          Try our other platforms
        </h1>
        <!-- <p class="login-container__platforms__content__description">
          Lorem ipsum dolor sit amet, qui veniam sensibus id. Ei eos ornatus quaestio. Usu vidisse quaestio concludaturque et, et albucius omnesque.
        </p> -->
        <div class="login-container__platforms__container">
          <template v-for="(platform, index) in platforms">
            <div v-if="platform.name !== $platform" :class="`login-container__platforms__platform login-container__platforms__platform__${platform.name}`" :key="index">
              <img :src="`sh_static/platforms/${platform.icon ? platform.icon : `${platform.name}.png`}`">
              <p v-html="platform.description" class="login-container__platforms__platform__description"></p>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import notifications from '@sh/mixins/notifications';

export default {
  name: 'Login',
  mixins: [notifications],
  data() {
    return {
      username: '',
      password: '',
      showPaymentError: false,
      paymentErrorText: '',
      paymentLink: '',
      loading: false,
      platforms: [
        {
          name: 'clickflare',
          icon: 'ClickFlare.svg',
          description: `The Tracker of choice for <b>Affiliates, Search Arbitrage, eCom, Lead Generation</b> and more. Built in Conversion API and Cost Tracking integrations for all the major platforms. Direct connection with Search Feed providers.
          <br>
          <ul>
            <li>Conversion API Integrations: Facebook, Google Ads, TikTok</li>
            <li>Cost Tracking Integrations: Facebook, TikTok, Google Ads, Taboola, Outbrain, RevContent, Mgid</li>
            <li>Search Feed Integrations: Tonic, System1, Bodis, Sedo and Domain Active, Ads.com</li>
          </ul>
          <a class="trial-button" fs-14" href="https://clickflare.io/?utm_campaign=optimizer_login_page&cpid=63c058719097e90012994076" target="_blank"> Start Free Trial </a> (No credit card required)`,
        },
        {
          name: 'landerlab',
          icon: 'LanderLab.svg',
          description: `Build fast and optimized landing pages that convert! 
          <br>
          No coding, no server skills needed! With Landerlab, you can create, edit, publish and host (yes hosting is included) beautiful and responsive landing pages that convert in a matter of clicks. 
          <br>
          <a class="trial-button" fs-14 mt-10" href="https://landerlab.io/?utm_campaign=optimizer_login_page&cpid=64dfe122de76b90012195cc6" target="_blank"> Start Free Trial </a> (No credit card required)`,
        },
      ],
    };
  },
  computed: {

    $c_signupUrl() {
      switch (this.$platform) {
        case 'native':
          return 'https://membership.theoptimizer.io/signup';
        case 'mobile':
          return 'https://membership.theoptimizer.io/signup/mobile';
        default:
          return '';
      }
    },
  },
  watch: {

    username() {
      this.$validator.errors.remove('login');
    },
    password() {
      this.$validator.errors.remove('login');
    },
  },
  methods: {
    async $_loginAction() {
      if (!await this.$validator.validateAll()) return;
      this.loading = true;
      try {
        const { token } = await this.$api.auth.login(this.username, this.password);
        if (token) {
          this.$session.setToken(token);
          // console.log(this.$session, this.$session.isAuthenticated());
          if (this.$session.isAuthenticated()) {
            this.$router.push({ name: 'Home' });
          } else {
            this.$n_failNotification({ title: 'Wrong token received.' });
          }
        } else {
          this.$n_failNotification({ title: 'An error ocurred. Try again later.' });
        }
      } catch (err) {
        if (err.response.status === 401) {
          this.$n_failNotification({ title: err.response.data.message || 'Bad credentials' });
        } else if (err.response.status === 400) {
          const isPaymentError = err.response.data.message.includes('No active subscription');
          if (isPaymentError) {
            this.showPaymentError = true;
            this.paymentErrorText = 'No active subscription!';
            this.paymentLink = 'https://membership.theoptimizer.io/';
          } else {
            this.$n_failNotification({ title: err.response.data.message });
          }
        } else {
          this.$n_failNotification({ title: 'An error ocurred. Try again later.' });
        }
      }
      this.loading = false;
    },
  },
};
</script>

<style lang="scss">
  .login-container {
    min-height: 100vh;
    display: flex;

    &__login-body {
      width: 63%;
      background: $color-white;

      &.tracker {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      }

      &__logo {
        margin: 3rem 0 calc((100vh - 50rem) / 2) 3rem;
        width: 15rem;
        pointer-events: none;
        &.tracker {
          margin: 6rem 0;
        }
      }

      &__form {
        width: 40rem;
        margin: 0 auto;
        text-align: center;

        &__logo {
          width: 15rem;
          margin-bottom: 3rem;
        }

        .login-form-title {
          font-size: 2.7rem;
          font-weight: 500;
          color: #000;
          margin-bottom: 3rem;
          &.tracker {
            color:  #273B4A;
            font-size: 3.2rem;
            font-weight: bold;
          }
        }

        .optimizer-form-group {
          margin-bottom: 2rem;

          .form-input {
            height: 4rem;
            padding-left: 1.5rem;
            padding-right: 1.5rem;
            border-radius: .6rem;
            font-size: 1.4rem;
            &.tracker {
              height: 5rem;
            }
          }
        }

        .form-link {
          display: inline-block;
          margin-bottom: 2.5rem;
          font-size: 1.4rem;
          color: $color-light-blue;
        }

        .login-btn {
          font-size: 1.5rem;
          text-transform: uppercase;
          width: 100%;
          background: $color-light-blue;
          border-color: $color-light-blue;
          border-radius: .6rem;
          margin-bottom: 2.5rem;
          padding: .8rem;

          &:hover,
          &:active,
          &:focus {
            background: #0fa8d6 !important;
            border-color: #0fa8d6 !important;
          }

          &.tracker {
            background:#3C81FC;
            border-color:#3C81FC;
            padding: 1.2rem;
          }
        }

        .sign-up-text {
          font-size: 1.4rem;
          margin-bottom: 0;

          .form-link {
            margin: 0;
          }
        }

      }
    }

    &__platforms {
      position: relative;
      background-color: $color-darker-blue;
      width: 37%;

      .optimizer-hexagon-img {
        position: absolute;
        right: 0;
        pointer-events: none;
      }

      &__content {
        padding: 6rem 5% 4rem 5%;
        color: #fff;

        &__title {
          font-size: 2.4rem;
          font-weight: normal;
          margin-bottom: 1.5rem;
        }

        &__description {
          font-size: 1.4rem;
          font-weight: 300;
          color: #d8d8d8;
          margin-bottom: 3.5rem;
        }
      }

      &__container {
        height: calc(100vh - 17rem);
        overflow-y: auto;

        &::-webkit-scrollbar {
          width: 0;
        }
      }

      &__platform {
        background: rgba(16, 18, 69, 0.8);
        color: #C6C7E9;
        font-weight: normal;
        border-radius: 1rem;
        padding: 2rem;
        margin-bottom: 2.5rem;

        &:last-of-type {
          margin-bottom: 0;
        }

        img {
          margin-bottom: 1.5rem;
          pointer-events: none;
          max-width: 12.5rem;
          max-height: 3.4rem;
        }

        ul {
          margin: 0;
        }


        .trial-button {
          font-family: 'Inter', sans-serif;
          padding: 1.2rem 2rem;
          text-align: center;
          text-decoration: none !important;
          background-color: white;
          border-radius: 1rem;
          font-size: 1.4rem;
          font-weight: 500;
          color: black !important;
          margin-top: 1rem;
          margin-right: 0.8rem;
        }

        &__description {
          font-size: 1.5rem;

          a {
            display: inline-block;
            text-decoration: underline;
            color: $color-light-blue;
          }
        }

        &__calculator {
          img {
            height: 3rem;
          }
        }
      }
    }
  }
  .error-message {
  background-color: #f2dede;
  color: #a94442;
  border: 1px solid #ebccd1;
  border-radius: 8px;
  padding: 10px;
  margin-bottom: 10px;
}

  @media (max-width: 767.98px) {
    .login-container {
      display: block;

      &__login-body {
        width: 100%;
        padding: 0 2rem 1rem;
        text-align: center;

        &__logo {
          margin: 2rem 0;
        }

        &__form {
          width: 100%;
        }
      }

      &__platforms {
        width: 100%;
        &__container {
          height: auto;
          overflow-y: none;
        }
      }
    }
  }
</style>
